import { Plugin } from '@ckeditor/ckeditor5-core';

export default class TooltipDisplay extends Plugin {
    init() {
        const editor = this.editor;
        const view = editor.editing.view;

        this._tooltipBox = null;

        this.listenTo(view.document, 'mouseover', (evt, data) => {
            const target = data.domTarget;

            if (target && target.classList && target.classList.contains('ck5-tooltip')) {
                const tooltipText = target.getAttribute('data');
                if (tooltipText) {
                    this._showTooltip(target, tooltipText);
                }
            }
        });

        this.listenTo(view.document, 'mouseout', (evt, data) => {
            const target = data.domTarget;
            if (target && target.classList && target.classList.contains('ck5-tooltip')) {
                this._hideTooltip();
            }
        });

        this.listenTo(view.document, 'scroll', () => {
            this._hideTooltip();
        });
    }

    _showTooltip(targetElement, text) {
        this._hideTooltip();

        const tooltip = document.createElement('div');
        tooltip.classList.add('ck5-tooltip-box');
        tooltip.textContent = text;
        document.body.appendChild(tooltip);
        this._tooltipBox = tooltip;

        this._positionTooltip(targetElement, tooltip);
    }

    _hideTooltip() {
        if (this._tooltipBox) {
            this._tooltipBox.remove();
            this._tooltipBox = null;
        }
    }

    _positionTooltip(target, tooltip) {
        const targetRect = target.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const spacing = 5;

        let top = targetRect.top - tooltipRect.height - spacing;
        let left = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);

        if (top < 0) {
            top = targetRect.bottom + spacing;
        }

        if (left < 0) {
            left = 5;
        }

        if (left + tooltipRect.width > window.innerWidth) {
            left = window.innerWidth - tooltipRect.width - 5;
        }

        tooltip.style.top = `${top + window.scrollY}px`;
        tooltip.style.left = `${left + window.scrollX}px`;
    }
}
